import { Country } from 'country-state-city';

/**
 * Show ISO code + full country name when value is a 2-letter code (e.g. IN-India).
 * Accepts full country names and returns CODE-Name when resolvable.
 */
export function formatCountryLabel(value) {
  if (value == null || value === '' || value === '—') return '—';
  const s = String(value).trim();
  if (!s || s === '—') return '—';

  const iso2 = s.toUpperCase();
  if (iso2.length === 2 && /^[A-Z]{2}$/.test(iso2)) {
    try {
      const c = Country.getCountryByCode(iso2);
      if (c?.name) return `${iso2}-${c.name}`;
    } catch {
      /* ignore */
    }
  }

  try {
    const match = Country.getAllCountries().find(
      (c) => c.name.toLowerCase() === s.toLowerCase()
    );
    if (match?.isoCode && match?.name) {
      return `${match.isoCode}-${match.name}`;
    }
  } catch {
    /* ignore */
  }

  return s;
}
